<template>
  <span :class="`a-avatar-primary a-avatar-side a-avatar-${avatarClass}`">
    <img
      v-if="userImage.length"
      key="avatarImg"
      :src="userImage"
    >
    <img
      v-else
      key="defaultImg"
      src="@/assets/img/avatar.png"
    >
  </span>
</template>

<script>
export default {
  name: 'AtomAvatarSecondary',

  props: {
    avatarClass: {
      type: String,
      default: 'small'
    },

    userImage: {
      type: String,
      default: ''
    }
  }
}
</script>
